<script>
</script>

<div>

	<p class="header"><strong>Sequencer is entering a new phase of development</strong></p>

	<p>Foundry VTT continues to change, and keeping Sequencer working well across new major versions takes ongoing
		effort. To properly support Foundry v14 and future releases, Sequencer will have to be re-written and undergo
		a long-overdue user interface update.</p>

	<p>Planned improvements include:</p>

	<ul>
		<li>Improvements to the renderer & effects</li>
		<li>Support for copying tokens with token rings</li>
		<li>Dark mode and light mode support</li>
		<li>Cleanup of older UI and systems for better stability</li>
	</ul>

	<p>Sequencer will remain <strong>free and fully functional</strong>. Critical fixes and Foundry compatibility updates
		will always be
		available to everyone.</p>

	<p>However, if Sequencer is useful to you and you would like to support this next phase of development, you can do so
		here:</p>

	<div class="sequencer-support">
		<span>
			<a class="sequencer-clickable-link" href="https://www.patreon.com/cw/fantasycomputerworks">
				<i class="fa-brands fa-patreon"></i> <span>Support us on Patreon</span>
			</a>
		</span>
	</div>

	<p>Your support helps fund maintenance, UI improvements, and long-term sustainability for Sequencer and our other
		free tools.</p>

	<p>Thank you for using Sequencer and for supporting the Foundry community.</p>

	<p>- Fantasy Computerworks</p>

</div>

<style lang="scss">

  div {

    margin-bottom: 0.5rem;
    font-size: 0.9rem;

    .header-icon {
      font-size: 3rem;
      margin: 0;
      text-align: center;
    }

    .header {
      margin-bottom: 0.5rem;
      font-size: 1.2rem;
      text-align: center;
    }

    .sequencer-support {
      display: grid;
      grid-template-columns: 1fr;
      text-align: center;
      margin: 1.5rem 0;

      a {
        font-size: 1.25rem;
        color: var(--color-primary);
        text-decoration: none;

        p {
          font-size: 0.8rem;
        }
      }
    }

  }

</style>
